function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5 8.125C17.1583 8.125 16.875 7.84167 16.875 7.5V3.125H12.5C12.1583 3.125 11.875 2.84167 11.875 2.5C11.875 2.15833 12.1583 1.875 12.5 1.875H17.5C17.8417 1.875 18.125 2.15833 18.125 2.5V7.5C18.125 7.84167 17.8417 8.125 17.5 8.125Z",
  fill: "#0851B5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 18.125H2.5C2.15833 18.125 1.875 17.8417 1.875 17.5V12.5C1.875 12.1583 2.15833 11.875 2.5 11.875C2.84167 11.875 3.125 12.1583 3.125 12.5V16.875H7.5C7.84167 16.875 8.125 17.1583 8.125 17.5C8.125 17.8417 7.84167 18.125 7.5 18.125Z",
  fill: "#0851B5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 9.37511C11.0917 9.37511 10.9333 9.31678 10.8083 9.19178C10.5667 8.95011 10.5667 8.55011 10.8083 8.30845L17.0583 2.05845C17.3 1.81678 17.7 1.81678 17.9417 2.05845C18.1833 2.30011 18.1833 2.70011 17.9417 2.94178L11.6917 9.19178C11.5667 9.31678 11.4083 9.37511 11.25 9.37511Z",
  fill: "#0851B5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.49999 18.1251C2.34166 18.1251 2.18333 18.0668 2.05833 17.9418C1.81666 17.7001 1.81666 17.3001 2.05833 17.0584L8.30833 10.8084C8.54999 10.5668 8.94999 10.5668 9.19166 10.8084C9.43333 11.0501 9.43333 11.4501 9.19166 11.6918L2.94166 17.9418C2.81666 18.0668 2.65833 18.1251 2.49999 18.1251Z",
  fill: "#0851B5"
});

var SvgMaximize4 = function SvgMaximize4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaximize4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maximize-4.b48c3177.svg";
export { ForwardRef as ReactComponent };